<template>
  <div class="body">
    <div class="body-box">
      <div class="login-box">
        <h1>管理员登录</h1>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="账号">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="form.password"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">登陆</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
export default {
  data() {
    return {
      form: {
        name: "",
        password: "",
      },
    };
  },
  created() {},
  methods: {
    onSubmit() {
      this.$store.commit("increment", {
        isl: true,
      });
      this.$router.push("manger");

      //   axios
      //     .post("http://127.0.0.1:8000/api/login", {
      //       name: this.form.name,
      //       password: this.form.password,
      //     })
      //     .then((res) => {
      //       if (res.data == "success") {
      //         this.$store.commit("increment", {
      //           isl: true,
      //         });
      //         this.$router.push("manger");
      //       } else {
      //         alert("账号密码错误");
      //         return;
      //       }
      //     })
      //     .catch(() => {
      //       alert("账号密码错误");
      //     });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.login-box {
  width: 30vw;
  height: 500px;

  text-align: center;
  padding: 50px;
  color: #363434;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
}
.login-box h1 {
  margin-left: 80px;
}
.body-box {
  /* background-color: aquamarine; */

  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
h1 {
  margin-bottom: 25px;
}
.body {
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(135deg, #92ffc0 10%, #002661 100%);
}
</style>